import { render, staticRenderFns } from "./booth-presenter-modal.vue?vue&type=template&id=8505f8de&scoped=true&"
import script from "./booth-presenter-modal.vue?vue&type=script&lang=js&"
export * from "./booth-presenter-modal.vue?vue&type=script&lang=js&"
import style0 from "./booth-presenter-modal.vue?vue&type=style&index=0&id=8505f8de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505f8de",
  null
  
)

export default component.exports